import styled from "styled-components";

export const Container = styled.main`
  section{
    max-width: 680px;
    margin: 0 auto;
    border: 1px solid var(--gray_c);
    border-radius: 24px;
  }

  @media screen and (min-width: 501px){
  }

  @media (max-width: 500px){
    
  }
`